<template>
  <b-button 
    :size="size" 
    :class="cssClass"
    @click="copyToClipboard"
    :disabled="isSuccess"
  >
    <b-icon
      :icon="buttonIcon"
    />
    {{ isSuccess ? 'Copied!' : buttonText }}
  </b-button>
</template>

<script>

export default {
  components: {
  },
  props: {
    copyContent: { type: String, required: true },
    buttonText: { type: String, default: 'Copy' },
    icon: { type: String, default: 'files' },
    size: { type: String, default: '' },
    cssClass: { type: String, default: '' }
  },
  data() {
    return {
      successMessageDuration: 1000,
      isSuccess: false,
    }
  },
  computed: {
    buttonIcon() {
      return this.isSuccess ? 'check-circle' : this.icon;
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.copyContent);
        this.showSuccess();
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    },
    showSuccess() {
      this.isSuccess = true;
      setTimeout(() => {
        this.isSuccess = false;
      }, this.successMessageDuration);
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
